import React from 'react'
import PropTypes from 'prop-types'
import {Button, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../../../utils/cloudinary-utils'
const StoryButton = ({buttonLink, buttonText, buttonColor}) => {
    return (
        <Button
            as={Link}
            href={buttonLink}
            marginTop="20px"
            variant="storyComponentLink"
            color={buttonColor}
            aria-label={buttonText}
            position="relative"
            fontSize={{base: '14px', md: '17px'}}
        >
            {buttonText}
            <Image
                alt="Arrow"
                transition="all .3s ease-in-out"
                width="15px"
                height="16px"
                src={getUrl('UIImages/images/right-arrow-icon.svg')}
            />
        </Button>
    )
}

StoryButton.propTypes = {
    buttonLink: PropTypes.string,
    buttonText: PropTypes.string,
    buttonColor: PropTypes.string
}

export default StoryButton
